var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-select",class:{ 'is-invalid': _vm.invalid }},[_c('select',{ref:"select",staticClass:"form-select form-select-sm",attrs:{"disabled":_vm.disabled}})])
}
var staticRenderFns = []

export { render, staticRenderFns }